import styled from '@emotion/styled/macro';

const ErrorNotFound = () => {
  return <Container>Error Page Not Found</Container>;
};

const Container = styled.div``;

export { ErrorNotFound };
